import * as types from './mutation-types';
import _ from 'lodash';
import {hasUnreadNotifications} from './getters';
import axios from 'axios';
import countryService from '../ml/services/countryService';
import echoService from '../ml/services/echoService';
import folderService from '../ml/services/folderService';
import googleService from '../ml/services/googleService';
import subscriptionService from '../ml/services/subscriptionService';
import shareTemplateService from '../ml/services/shareTemplateService';
import shareThemeService from '../ml/services/shareThemeService';
import DOMPurify from 'dompurify';
import brandService from '../v2/app/services/brandService';
import fingerprintService from '../v2/app/services/fingerprintService';
import userPermissionService from '../v2/app/services/userPermissionService';
import userService from '../ml/services/userService';
import fetchService from '../v2/app/services/fetchService';
import emailVerificationService from '../v2/app/services/emailVerificationService';
import vueStateService from '../v2/app/services/vueStateService';
import teamService from '../ml/services/teamService';

export const clearSavedState = (context) => {
  vueStateService.clearSavedState();
};

/**
 * MLD-5199
 * @param context
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchAccountManagers = (context) => {
  return axios.get(`/api/account-managers`)
    .then(response => {
      context.commit('setAccountManagers', response.data);
    })
}

/**
 * MLD-5199
 * @param context
 * @param teamID
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchAccountManager = (context, teamID) => {
  return axios.get(`/api/teams/${teamID}/account-manager`)
    .then(response => {
      context.commit('setAccountManager', response.data);
    })
}
export const getCountries = (context) => {
  return countryService.getCountries()
    .then(data => {
      context.commit(types.SET_COUNTRIES, data);
      return data;
    })
};

export const getDevices = async (context) => {
  // MLD-7873
  try {
    const devices = await fetchService.fetchRecords(`/api/teams/${context.state.user.current_team_id}/devices`, {}, 1_000)
    context.commit(types.SET_DEVICES, devices);
    return devices;
  } catch (error) {
    console.log('Error retrieving devices', error.message);
    return [];
  }
  /*return axios.get(`/api/admin/teams/${context.state.user.current_team_id}/devices`)
    .then((response) => {
      context.commit(types.SET_DEVICES, response.data);
      return response.data;
    })
    .catch((err) => {
      console.log('Error retrieving devices', err.data);
      throw err;
    });*/
};
export const getDevice = (context, deviceId) => {
  return axios.get(`/api/admin/devices/${deviceId}`)
    .then((response) => {
      context.commit(types.SET_DEVICE, response.data);
      return response.data;
    })
    .catch((err) => {
      console.log('Error retrieving devices', err.data);
      throw err;
    });
};
export const setDevices = (context, devices) => {
  context.commit(types.SET_DEVICES, devices);
};
export const getFolders = async (context) => {
  const folders = await folderService.getFolders();
  context.commit(types.SET_FOLDERS, folders);
};
export const getGroups = (context) => {
  return axios.get(`/api/admin/teams/${context.state.user.current_team_id}/groups`).then((response) => {
    context.commit(types.SET_GROUPS, response.data);
    return response.data;
  }).catch((err) => {
    console.log('Error retrieving groups', err.data);
    throw err;
  });
};
export const getGroup = (context, groupId) => {
  return axios.get(`/api/admin/groups/${groupId}`)
    .then((response) => {
      context.commit(types.SET_GROUP, response.data);
      return response.data;
    }).catch((err) => {
      console.log('Error retrieving groups', err.data);
      throw err;
    });
};
export const getLabels = (context) => {
  return axios.get(`/api/labels`)
    .then((response) => {
      context.commit(types.SET_LABELS, response.data);
      return response.data;
    })
    .catch((err) => {
      console.log('Error in getLabels() action', err.data);
      throw err;
    });
};
export const getLabel = (context, labelId) => {
  return axios.get(`/api/admin/labels/${labelId}`)
    .then((response) => {
      context.commit(types.SET_LABEL, response.data);
      return response.data;
    })
    .catch((err) => {
      console.log('Error in getLabel() action', err.data);
      throw err;
    });
};
export const getAnnouncementsAndNotifications = (context) => {
  return axios.get('/api/admin/notifications/recent')
    .then((response) => {
      context.commit(types.SET_NOTIFICATIONS, response.data.notifications);
      context.commit(types.SET_ANNOUNCEMENTS, response.data.announcements);
      return response.data;
    })
};
export const getPresentations = async (context) => {
  let presentations = [];
  try {
    const url = `/api/teams/${context?.state?.user?.current_team_id}/presentations`;
    const chunkSize = 200;
    const concurrentRequests = 3;
    const label = `getPresentations: chunkSize = ${chunkSize} concurrentRequests = ${concurrentRequests}`;

    console.time(label);
    presentations = await fetchService.fetchRecords(url, {}, chunkSize, concurrentRequests)
    context.commit(types.SET_PRESENTATIONS, presentations);
    console.timeEnd(label);
  } catch (e) {
    console.log('getPresentations exception:', e.message);
    context.commit(types.SET_PRESENTATIONS, presentations);
  }
  return Promise.resolve(presentations);
}
export const getPresentation = (context, presentationId) => {
  //console.log('getPresentation()', `/api/admin/presentations/${presentationId}`);
  return axios.get(`/api/admin/presentations/${presentationId}`)
    .then((response) => {
      context.commit(types.SET_PRESENTATION, response.data);
      return response.data;
    })
    .catch((err) => {
      console.log(`Error retrieving presentation ${presentationId}`, err.data);
      throw err;
    });
};
export const getBrands = (context) => { // MLD-4796
  return brandService.getBrands()
    .then(data => {
      context.commit('setBrands', data)
      return data;
    })
}
export const getProducts = (context) => { // MLD-3306
  return axios.get(`/api/products`)
    .then(response => {
      const products = _.orderBy(response.data, ['slug'])
      context.commit('setProducts', products);
      return products;
    })
}
export const getShareTemplates = context => {
  return shareTemplateService.getAllTemplates()
    .then(data => {
      context.commit(types.SET_SHARE_TEMPLATES, _.orderBy(data, ['is_default', 'name'], ['desc', 'asc']));
      return data;
    })
};
export const getTimezones = context => {
  if (window.ML && window.ML.timezones) {
    context.commit(types.SET_TIMEZONES, ML.timezones);
  }
  return Promise.resolve(ML.timezones);
};
/**
 * MLD-1323
 * @param context
 * @returns {Promise<unknown>}
 */
export const getLocales = context => {
  return axios.get(`/api/locales`)
    .then(response => {
      context.commit(types.SET_LOCALES, response.data);
      return response.data;
    })
};
export const markNotificationsAsRead = (context) => {
  if (!hasUnreadNotifications(context.state)) {
    return;
  }

  const ids = _.map(context.state.notifications, notification => {
    return notification.id;
  });

  axios.put('/api/admin/notifications/read', {
    notifications: ids,
  })
    .then(() => {
      context.commit(types.READ_NOTIFICATIONS)
    });
};
export const setCurrentPresentationID = (context, presentationID) => {
  context.commit(types.SET_CURRENT_PRESENTATION_ID, presentationID);
  return true;
};
export const setCurrentPresentation = (context, presentation) => {
  context.commit(types.SET_CURRENT_PRESENTATION, presentation);
  context.commit(types.SET_PRESENTATION, presentation);
}
export const setSpark = (context, spark) => {
  context.commit(types.SET_SPARK, spark);
  return true;
};
export const getTeam = (context, teamId) => {
  return axios.get(`/api/admin/teams/${teamId}`)
    .then((response) => {
      setTeam(context, response.data);
      return response.data;
    })
    .catch((err) => {
      console.log(`Error retrieving team ${teamId}`, err.data);
      throw err;
    })
};
export const setTeam = (context, team) => {
  context.commit(types.SET_TEAM, team);
};
export const getUser = (context, userId) => {
  return axios.get('/api/admin/users/' + userId)
    .then((response) => {
      context.commit(types.SET_USER, response.data);
      return response.data;
    })
    .catch((err) => {
      console.log(`Error retrieving user ${userId}`, err.data);
      throw err;
    });
};

export const getUsers = async (context) => {
  //return [];
  //return await fetchService.testFetching('/api/users');
  context.commit('loadingUsers', true);
  const url = `/api/users`;
  const chunkSize = 100;
  const concurrentRequests = 4;
  const label = `getUsers: chunkSize = ${chunkSize} concurrentRequests = ${concurrentRequests}`;
  let users = [];
  try {
    console.time(label);
    users = await fetchService.fetchRecords(url, {}, chunkSize, concurrentRequests)
    console.timeEnd(label);
    context.commit(types.SET_USERS, users);
  } catch (e) {
    console.log('getUsers() exception:', e.message);
    context.commit(types.SET_USERS, users);
  } finally {
    context.commit('loadingUsers', false);
  }
  return Promise.resolve(users);

};
export const fetchPermissions = (context) => {
  return userPermissionService.getPermissions()
    .then(permissions => {
      context.commit('setPermissions', permissions);
    })
}
export const getCurrentTeams = (context) => { // MLD-7272 The current user's teams.
  return teamService.getCurrentTeams()
    .then(teams => {
      context.commit(types.SET_TEAMS, teams);
    })
    .catch((err) => {
      console.log(`Error retrieving current teams`, err);
      throw err;
    })
};
export const getCurrentUser = (context) => {
  return userService.getCurrentUser()
    .then(user => {
      context.commit(types.SET_CURRENT_USER, user);
      context.commit('setPermissions', user.permissions); // MLD-5518
      return true;
    })
    .catch((err) => {
      console.log(`Error retrieving current user`, err);
      throw err;
    });
};
export const setCurrentUser = (context, currentUser) => {
  context.commit(types.SET_CURRENT_USER, currentUser);
};
export const toggleSidebar = (context) => {
  context.commit(types.TOGGLE_SIDEBAR);
}
export const setTitle = (context, title) => {
  const scrubbed = DOMPurify.sanitize(title); // MLD-4779
  if (context.state.title !== scrubbed) {
    //console.log('setTitle()', scrubbed);
    context.commit(types.SET_TITLE, scrubbed);
    document.title = scrubbed;
  }
};

/**
 * MLD-5093
 * @param context
 * @returns {Promise<{bot: true, botKind: BotKind} | {bot: false}>}
 */
export const detectBots = (context) => {
  return fingerprintService.detectBot()
    .then(result => {
      context.commit('setBotResult', result);
      return result;
    })
}

// MLD-967
export const getShareThemes = (context) => {
  return shareThemeService.getThemes()
    .then(data => {
      context.commit(types.SET_SHARE_THEMES, _.orderBy(data, ['is_default', 'name'], ['desc', 'asc']));
      return data;
    })
};

// MLD-6180
export const fetchEmailCreditInfo = (context) => {
  return emailVerificationService.getInfo()
    .then(data => {
      context.commit('setEmailCreditInfo', data)
    })
    .catch(err => {

    })
}

function catchException(err) {

}

export const initStore = async (store) => {
  const ML = window.ML;
  //console.log('initStore() called');

  detectBots(store).then().catch(catchException); // MLD-5093

  if (ML && ML.user) {
    await getCurrentTeams(store);
    await getCurrentUser(store);

    getPresentations(store).then().catch(catchException);

    fetchAccountManagers(store).then().catch(catchException); // MLD-5199
    fetchAccountManager(store, ML.user.current_team_id).then().catch(catchException); // MLD-5199

    getBrands(store).then().catch(catchException); // MLD-4796
    // MLD-2456
    getCountries(store).then().catch(catchException);
    getGroups(store).then().catch(catchException);
    getDevices(store).then().catch(catchException);
    getLabels(store).then().catch(catchException);
    getLocales(store).then().catch(catchException);
    getProducts(store).then().catch(catchException); // MLD-3306
    getShareTemplates(store).then().catch(catchException);
    getShareThemes(store).then().catch(catchException);
    subscriptionService.getSubscriptions().then().catch(catchException);
    getTimezones(store).then().catch(catchException);

    // MLD-6180
    fetchEmailCreditInfo(store).then().catch(catchException);

    // MLD-3690 I moved these out of the Promise so the admin portal loads faster.
    setSpark(store, window.Spark);
    getUsers(store).then().catch(catchException);

    return Promise.all([
      //setCurrentUser(store, window.ML.user),
      echoService.boot(),
      googleService.boot(),
    ]);
  } else {
    return Promise.all([]);
  }
};
